import type { IGenderDefault, IGenders } from '../models';

const FEMALE_SHORT = 'f';
const MALE_SHORT = 'm';

export const FEMALE = 'f';
export const MALE = 'm';

export const genderDefault: IGenderDefault = {
    caption: 'Пол',
    errorCaption: 'Поле обязательно для заполнения',
    name: 'sex',
    size: 'm',
};

export const genders: IGenders[] = [
    { value: FEMALE_SHORT, label: 'Женский' },
    { value: MALE_SHORT, label: 'Мужской' },
];
